import { WkSwitch } from '@wk/components-v3-react16';
import React from 'react';
import { useAtom } from 'jotai';
import { dashboardFilterAtom } from '../filterAtom';
import ResubmitButton from './ResubmitButton/ResubmitButton';
import StopButton from './StopButton/StopButton';
import ClearFiltersButton from './ClearFiltersButton/ClearFiltersButton';
import styles from './PanelAboveDashboard.module.scss';

const PanelAboveDashboard = () => {
  const [filters, setFilters] = useAtom(dashboardFilterAtom);

  const isMyOrchestrationsOnly = filters.jobsOwner === 'USER_JOBS';

  const handleSwitchChange = () => {
    setFilters({
      ...filters,
      jobsOwner: isMyOrchestrationsOnly ? 'ALL_JOBS' : 'USER_JOBS',
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <WkSwitch
          isChecked={isMyOrchestrationsOnly}
          onSwitch={handleSwitchChange}
          label={'My orchestrations only'}
        />
      </div>
      <div className={styles.rightSection}>
        <ClearFiltersButton />
        <ResubmitButton />
        <StopButton />
      </div>
    </div>
  );
};

export default PanelAboveDashboard;
